import { BaseSyncOperation } from "@/store/sync/operations/BaseSyncOperation";
import { ICreateMessageSentSessionEventOperation } from "@/store/sync/operations/types";
import { OptimisticSyncUpdate, SyncModelData, SyncOperationKind } from "@/store/sync/types";
import { SessionEventModelData } from "@/store/sessions/types";
import { uuidModule } from "@/modules/uuid";

export class CreateMessageSentSessionEventOperation extends BaseSyncOperation<ICreateMessageSentSessionEventOperation> {
  get operationKind(): SyncOperationKind {
    return "CREATE_MESSAGE_SENT_SESSION_EVENT";
  }

  public async generateOptimisticUpdates(): Promise<OptimisticSyncUpdate<SyncModelData>[]> {
    const optimisticUpdates: OptimisticSyncUpdate<SyncModelData>[] = [];
    const eventUpdate = this.generateCreateMessageSentSessionEventUpdate();

    if (eventUpdate) optimisticUpdates.push(eventUpdate);

    return optimisticUpdates;
  }

  async triggerRecompute() {
    await this.store.sessionEvents.recompute(this.payload.id);
  }

  protected generateCreateMessageSentSessionEventUpdate(): OptimisticSyncUpdate<SessionEventModelData> {
    const optimisticUpdate: OptimisticSyncUpdate<SessionEventModelData> = {
      optimistic_update_id: uuidModule.generate(),
      locally_committed_at: this.committedAt,
      kind: "UPSERTED",
      value: {
        model_id: this.payload.id,
        model_kind: "SESSION_EVENT",
        model_version: 1,
        model_data: {
          id: this.payload.id,
          session_id: this.payload.session_id,
          kind: this.payload.event_kind,
          // SessionMessage is not a sync model, so we leave value_json empty for the optimistic update.
          // The backend will create a SessionMessage and put its ID in the value_json field
          // like { "message_id": "123" }, but the frontend will just receive the message data in the
          // event_value_json field (which we will rename).
          value_json: {},
          locally_created_at: new Date().toISOString(),
          // TODO: Rename to related_model_data
          event_value_json: this.payload.message_value_json as { [key: string]: unknown },
        },
        model_scopes: [],
      },
    };

    return optimisticUpdate;
  }
}
